import {
	ENDPOINT_FUNCTION_DARK_MODE,
	ENDPOINT_GET_LIMIT,
	ENDPOINT_PRT_FILE,
	ENDPOINT_DASHBOARD_METRICS_REPORT_TABLE,
	ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_BARPLOT,
	ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_DONUT,
	ENDPOINT_PAGINATED_ACTION_TRACKER_ISSUES,
	ENDPOINT_SHEET_UPDATE,
	ENDPOINT_EXPORT_METRICS,
	ENDPOINT_EXPORT_EBITS,
	ENDPOINT_EXPORT_ACTION_TRACKER_ISSUE,
	ENDPOINT_EXPORT_ACTIONS,
	ENDPOINT_EXPORT_KRI,
	ENDPOINT_EXPORT_CRITICAL_ASSET_PRT_FILES,
	ENDPOINT_EXPORT_CRITICAL_ASSET_REVISION,
	ENDPOINT_EXPORT_CRITICAL_ASSET_HISTORICAL,
	ENDPOINT_EXPORT_CRITICAL_ASSET_DISCHARGED,
	ENDPOINT_EXPORT_SPARE_PART_REVISION,
	ENDPOINT_EXPORT_SPARE_PART_HISTORICAL,
	ENDPOINT_EXPORT_SPARE_PART_DISCHARGED,
	ENDPOINT_EXPORT_USERS,
	ENDPOINT_EXPORT_TRACKING,
	ENDPOINT_EXPORT_ASI_REQUESTS,
	ENDPOINT_CRITICAL_ASSET_PRT_FILES,
	ENDPOINT_FISCAL_YEARS,
	ENDPOINT_CHANGE_FISCAL_YEAR,
	ENDPOINT_DASHBOARD_KRI_SUMMARY_TABLE,
	ENDPOINT_KRIS,
	ENDPOINT_DASHBOARD_KRI_REPORT_TABLE,
	ENDPOINT_DASHBOARD_KRI_PIVOT_TABLE,
	ENDPOINT_DASHBOARD_ACTIONS_PRIORITY_ACTIONS,
	ENDPOINT_DASHBOARD_ACTIONS_PRIORITY,
	ENDPOINT_DASHBOARD_METRICS_PERCENTAGE,
	ENDPOINT_HELPER_GET_CURRENT_FISCAL_YEAR,
	ENDPOINT_FUNCTION_DISCHARGE_PARTS,
	ENDPOINT_FUNCTION_CHECK_DISCHARGE_PARTS,
	ENDPOINT_UPLOAD_ACTIONS,
	ENDPOINT_CRITICAL_ASSET_BY_STATUS_NUMBER,
	ENDPOINT_CRITICAL_ASSET_BY_STATUS_VALUE,
	ENDPOINT_CRITICAL_ASSET_DETAIL_FUNCTIONAL_LOCATION,
	ENDPOINT_CRITICAL_ASSET_DETAIL_FL,
	ENDPOINT_CRITICAL_ASSET_BY_ORGANIZATION,
	ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER_ALL,
	ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER,
	ENDPOINT_CRITICAL_ASSETS_TO_CSV,
	ENDPOINT_SPARE_PART_TO_CSV,
	ENDPOINT_ACTIONS,
	ENDPOINT_CACHE_TO_CRITICAL_ASSET,
	ENDPOINT_CREATE_CRITICAL_ASSET,
	ENDPOINT_CRITICAL_ASSETS,
	ENDPOINT_ORGANIZATIONS,
	ENDPOINT_IMPACTED_AREAS,
	ENDPOINT_SPECIALITIES,
	ENDPOINT_PWO_COMPLIANCES,
	ENDPOINT_PWO_CANCELLEDS,
	ENDPOINT_PWO_OVERDUES,
	ENDPOINT_UPLOAD_PWO_SHEET,
	ENDPOINT_UPLOAD_ACTION_TRACKER,
	ENDPOINT_ACTION_TRACKER_ISSUES,
	ENDPOINT_USERS,
	ENDPOINT_USER,
	ENDPOINT_SPARE_PARTS,
	ENDPOINT_PRT_FILES,
	ENDPOINT_STANDARDS,
	ENDPOINT_STANDARD,
	ENDPOINT_CRITICAL_ASSET,
	ENDPOINT_SPARE_PART,
	ENDPOINT_AC_WITH_PRT_FILES,
	ENDPOINT_TOKEN_REFRESH,
	ENDPOINT_WORKFLOWS,
	ENDPOINT_WORKFLOW,
	ENDPOINT_WF_NULL,
	ENDPOINT_WORKFLOW_CRITICAL_ASSET,
	ENDPOINT_TRACK_ACTIVITIES,
	ENDPOINT_FORWARD_WORKFLOW,
	ENDPOINT_USER_ASSETS,
	ENDPOINT_PERMISSIONS,
	ENDPOINT_PERMISSION,
	ENDPOINT_PROFILES,
	ENDPOINT_PROFILE,
	ENDPOINT_IMPACTED_AREAS_EBITS,
	ENDPOINT_EBITS,
	ENDPOINT_EBIT,
	ENDPOINT_ROLE,
	ENDPOINT_ROLES,
	ENDPOINT_GENERIC_FILES,
	ENDPOINT_CREATE_CRITICAL_ASSET_CACHE,
	ENDPOINT_ADD_FILES_CRITICAL_ASSET,
	ENDPOINT_PRT_FILES_FILTER,
	ENDPOINT_KRI,
	ENDPOINT_UPLOAD_KRI,
	ENDPOINT_DATA_ACTION_TRACKER_TYPES,
	ENDPOINT_PUBLIC_FILE_1,
	ENDPOINT_DASHBOARD_METRICS_SPECIFIC_HEADERS,
	ENDPOINT_DASHBOARD_METRICS_SPECIFIC,
	ENDPOINT_CUSTOM_CREATE_USER,
	ENDPOINT_CUSTOM_UPDATE_USER,
	ENDPOINT_DASHBOARD_KRI_INDIVIDUAL_TABLE,
	ENDPOINT_EDIT_KRI_1_2,
	ENDPOINT_JOIN_CRITICAL_ASSET_DETAIL_FL,
	ENDPOINT_CRITICAL_ASSET_FILE_TYPES,
	ENDPOINT_SIMULATIONS_COMPUTED_VALUES_CRITICAL_ASSET,
	ENDPOINT_SIMULATIONS_COMPUTED_VALUES_SPARE_PART,
	ENDPOINT_ASSET_CLASS_A_ALL,

	
	ENDPOINT_ACTION_PHOTOGRAPHIC_RECORDS,
	ENDPOINT_ACTION_PHOTOGRAPHIC_RECORD,
	ENDPOINT_ACTION_DOCUMENTS,
	ENDPOINT_ACTION_DOCUMENT,

	ENDPOINT_ACTION_WORKFLOWS,
	ENDPOINT_REVIEW_ACTION,
	ENDPOINT_REMEDIATION_ACTIONS ,
	ENDPOINT_CLOSING_VALIDATION_ACTION,

	ENDPOINT_SIMULATIONS_CRITICAL_ASSETS,
	ENDPOINT_SIMULATIONS_SPARE_PARTS,
	ENDPOINT_SIMULATIONS_CRITICAL_ASSET,
	ENDPOINT_SIMULATIONS_SPARE_PART,
	ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_CRITICAL_ASSET,
	ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_SPARE_PART,
	ENDPOINT_FUNCTION_MANUAL_DISCHARGE_CRITICAL_ASSET,
	ENDPOINT_FUNCTION_MANUAL_DISCHARGE_SPARE_PART,
	ENDPOINT_DISCHARGE_PART_FILES,
	ENDPOINT_SIMULATIONS_JOIN_CA_WITH_SCAS,
	ENDPOINT_IMPACT_PERCENTAGE_FILES,
	ENDPOINT_IMPACT_PERCENTAGE_FILE,
} from '../config';
import axios from 'axios';
require('es6-promise').polyfill();
require('isomorphic-fetch');
import { enc, dec } from '../functions/general.js';
import $store from '../store';
//import $router from '../router';

const setRequestStatus = (name, status) => {
	const rs = $store.getters.requestStatus.find(f => f.name === name);
	if (!rs) return false;
	rs.status = status;
	if (['success', 'error'].includes(status)) {
		rs.ticking = true;
		status === 'success'
			? setTimeout(() => rs.ticking = false, 3000)
			: setTimeout(() => rs.ticking = false, 6000);
	}
	return rs;
};

const headers = () => {
	return {
		'accept-language': 'es-es',
		'Content-Type': 'application/json',
		Accept: 'application/json',
		Authorization: 'Bearer '+ $store.getters.session.access
	}
};
const Authorization = () => {
	return 'Bearer '+ $store.getters.session.access
}
const PATCH = (obj) => {
	return{
		method: 'PATCH',
		headers: headers(),
		body: JSON.stringify(obj)
	}
};
const PATCHmulti = (obj) => {
	const formData = new FormData();
	
	Object.keys(obj).forEach(k => {
		formData.append(k,obj[k])
	});
	return{
		method: 'PATCH',
		headers : { 
			Authorization: Authorization(),
			Accept: 'application/json'
		},
		body: formData
	}
};
const PUT = (obj) => {
	return{
		method: 'PUT',
		headers: headers(),
		body: JSON.stringify(obj)
	}
};

const PUTmulti = (obj) => {
	const formData = new FormData();
	
	Object.keys(obj).forEach(k => {
		formData.append(k,obj[k])
	});
	return{
		method: 'PUT',
		headers : { 
			Authorization: Authorization(),
			Accept: 'application/json'
		},
		body: formData
	}
};
const FD = (obj) => {
	const formData = new FormData();
	const formData2 = new FormData();
	Object.keys(obj['prt_files']).forEach(k => {
		formData2.append(k,obj[k])
	}); 
	Object.keys(obj).forEach(k => {
		if(k !== 'prt_files') {
			formData.append(k,obj[k])

			
		} else {
			obj['prt_files'].forEach(p => {
				formData.append(`${k}[]`,p)
			}); 
			
		}
	});

	return formData
}
const POSTmulti2 =  (obj) => {
/* 	const formData = new FormData();
	const formData2 = new FormData();
	Object.keys(obj).forEach(k => {
		if(k !== 'prt_files') formData.append(k,obj[k])
	});
	Object.keys(obj['prt_files']).forEach(k => {
		formData2.append(k,obj[k])
	}); */
	//obj['prt_files'] = formData2
	//formData.append('prt_files',formData2)
	
	return{
		method: 'POST',
		headers : {
			Authorization: Authorization(),
			Accept: 'application/json'
		},
		body:  JSON.stringify(obj)
	}
};
function getFormData(formData, data, previousKey) {
	if (data instanceof Object) {
	  Object.keys(data).forEach(key => {
		const value = data[key];
		if (value instanceof Object && !Array.isArray(value) && !(value instanceof File)) {
			
		  return getFormData(formData, value, key);
		}
		if (previousKey) {
		  key = `${previousKey}[${key}]`;
		}
		if (Array.isArray(value)) {
		  value.forEach(val => {
			formData.append(`${key}[]`, val);
		  });
		} else {
		  formData.append(key, value);
		}
	  });
	}
  }
const POSTmulti =  (obj) => {
	const formData = new FormData();
	getFormData(formData, obj)

	return{
		method: 'POST',
		headers : {
			Authorization: Authorization(),
			Accept: 'application/json'
		},
		body:  formData
	}
};

const POST = (obj) => {
	return{
		method: 'POST',
		headers: headers(),
		body: JSON.stringify(obj)
	}
};

export const GET = () => {
	return { method: 'GET', headers: headers() }
};

const GET2 = (obj) => {
	return{
		method: 'GET',
		headers: headers(),
		body: JSON.stringify(obj)
	}
};

const DELETE = () => {
	return{
		method: 'DELETE',
		headers: headers(),
	}
};

const serializeFilterValue = (value) => {
	if (Array.isArray(value)) return `[${value.join(',')}]`;
	if (value && typeof value === 'object') return JSON.stringify(value);
	return value;
};

const setFilters = (filters) => {
	if (!filters) return '';
	const array = Object.keys(filters).map(k => {
		const key = encodeURIComponent(k);
		const value = encodeURIComponent(serializeFilterValue(filters[k]));
		return `${key}=${value}`;
	});
	return array.length ? `?${array.join('&')}` : '';
}


export const getRefresh = () => dec(localStorage.getItem('AS2X'));
export const login = (obj) => !localStorage.getItem('AS2X') && localStorage.setItem('AS2X', enc(obj));
export const forceLogin = (obj) => localStorage.setItem('AS2X', enc(obj));

export const getAccess = async (login) =>
	getRefresh() &&
	fetch(ENDPOINT_TOKEN_REFRESH, POST({refresh: getRefresh()}))
		.then(res => res.json())	
		.then(data => data && data.access ? data : ($store.dispatch('logout') && false))
		.catch(e => console.error('Error verificar token',e) || $store.dispatch('logout'));

export const sendMailSoporte = (session, form) => {

	const {token} = session;
	/* const url = `${ENDPOINT_INVENTORY}/usuarios/mailing/soporte`;
	return axios.post(url, { form }, { headers: { Authorization: `Bearer ${token}` } }) */
}

export const getWorkflowNull = () => fetch(ENDPOINT_WF_NULL, GET())
	.then(res => res.json());
//-------------EDIT---------------------------------------
/*

*/
/* 
export const edit = (obj) => fetch(
	ENDPOINT_ + obj.id + '/',
	PUT(obj))
	.then(res => res.json());

export const copyProcedureSerial = (obj) => axiosaxios.put(ENDPOINT_COPY_TASK_IMAGE + obj.id + '/', headers);
 */
export const patch_function_dark_mode = (obj) => fetch(
	ENDPOINT_FUNCTION_DARK_MODE,
	PATCH(obj))
	.then(res => res.json());

const editPatch = (ENDPOINT) => (obj,id) => fetch(
	ENDPOINT + (id || obj.id) + '/',
	PATCH(obj))
	.then(res => res.json());
const editPatchmulti = (ENDPOINT) => (obj) => fetch(
	ENDPOINT + obj.id + '/',
	PATCHmulti(obj))
	.then(res => res.json());

export const edit_simulations_ca = editPatch(ENDPOINT_SIMULATIONS_CRITICAL_ASSET);
export const edit_simulations_sp = editPatch(ENDPOINT_SIMULATIONS_SPARE_PART);


export const edit_closing_validation_action = editPatch(ENDPOINT_CLOSING_VALIDATION_ACTION);

export const edit_prt_file = editPatchmulti(ENDPOINT_PRT_FILE);

export const editCustomCreateUser = editPatch(ENDPOINT_CUSTOM_UPDATE_USER);

const editMulti = (ENDPOINT) => (obj) => fetch(
	ENDPOINT + obj.id + '/',
	PUTmulti(obj))
	.then(res => res.json());


const edit = (ENDPOINT) => (obj) => fetch(
	ENDPOINT + obj.id + '/',
	PUT(obj))
	.then(res => res.json());

export const edit_action_document = editMulti(ENDPOINT_ACTION_DOCUMENT);
export const edit_function_manual_discharge_critical_asset = edit(ENDPOINT_FUNCTION_MANUAL_DISCHARGE_CRITICAL_ASSET);
export const edit_function_manual_discharge_spare_part = edit(ENDPOINT_FUNCTION_MANUAL_DISCHARGE_SPARE_PART);

export const editStandard = editMulti(ENDPOINT_STANDARD);

export const changeFiscalYear = (obj) => fetch(
	ENDPOINT_CHANGE_FISCAL_YEAR,
	PUT(obj))
	.then(res => res.json());

export const functionDischargeParts = (obj) => fetch(
	ENDPOINT_FUNCTION_DISCHARGE_PARTS,
	PUT({}))
	.then(res => res.json());

export const editRole = (obj) => fetch(
	ENDPOINT_ROLE + obj.id + '/',
	PUT(obj))
	.then(res => res.json());

export const editProfile = (obj) => fetch(
	ENDPOINT_PROFILE + obj.id + '/',
	PUT(obj))
	.then(res => res.json());

export const editEbit = (obj) => fetch(
	ENDPOINT_EBIT + obj.id + '/',
	PUT(obj))
	.then(res => res.json());

export const editForwardWorkflow = (filters, obj) => fetch(
	ENDPOINT_FORWARD_WORKFLOW + setFilters(filters) ,
	PUT(obj))
	.then(res => res.json())
	.then((r) => {
		require('@/store').default.dispatch('refreshMyManagementPendingViews');
		return r;
	});

export const editSparePart = (obj) => fetch(
	ENDPOINT_SPARE_PART + obj.id + '/',
	PUT(obj))
	.then(res => res)
	.then(res => res.json());

export const editCriticalAsset = (obj) => fetch(
	ENDPOINT_CRITICAL_ASSET + obj.id + '/',
	PUT(obj))
	.then(res => res)
	.then(res => res.json());

export const editUser = (obj) => fetch(
	ENDPOINT_USER + obj.id + '/',
	PUT(obj))
	.then(res => res.json());
// ------------DELETE--------------------------------------
/*

*/
/* 
export const deleteAditionalControl = (id) => fetch(
	`${ENDPOINT_ADITIONAL_CONTROL + id}/`,
	DELETE());
 */

const deleteItem = (ENDPOINT_) => (id) => fetch(
	`${ENDPOINT_ + id}/`,
	DELETE());
	

export const delete_impact_percentage_file = deleteItem(ENDPOINT_IMPACT_PERCENTAGE_FILE);

export const delete_prt_file = deleteItem(ENDPOINT_PRT_FILE);
export const delete_action_document = deleteItem(ENDPOINT_ACTION_DOCUMENT);
export const delete_action_photographic_record = deleteItem(ENDPOINT_ACTION_PHOTOGRAPHIC_RECORD);

// -----------GETS--------------------------------------------
const vld = (r, key) => [200,201].includes(r.status) ? setRequestStatus(key,'success') && r.json() : setRequestStatus(key,'error') && undefined;
const gets = (ENDPOINT, key) => (filters) => {
	const rs = $store.getters.requestStatus.find(f => f.name === key);
	// no consulta si la info esta
	if (![false, 'error'].includes(rs.status)) return rs.rq;
	setRequestStatus(key,'getting')
	rs.rq = fetch(ENDPOINT + setFilters(filters), GET())
		.then(r => vld(r, key))
		.catch(e => setRequestStatus(key,'error') && console.error(e));
	return rs.rq;
}



export const getAssetClass = gets(ENDPOINT_ASSET_CLASS_A_ALL, 'asset_class');

export const getCriticalAssetFileTypes = gets(ENDPOINT_CRITICAL_ASSET_FILE_TYPES, 'file_types');

export const getDashboardActionsPriorityActions = gets(ENDPOINT_DASHBOARD_ACTIONS_PRIORITY_ACTIONS, 'dashboard_actions_priority_actions');
export const getDashboardActionsPriority = gets(ENDPOINT_DASHBOARD_ACTIONS_PRIORITY, 'dashboard_actions_priority');


export const getDashboardMetricsPercentage = gets(ENDPOINT_DASHBOARD_METRICS_PERCENTAGE, 'dashboard_metrics_percentage');

export const getCriticalAssetByStatusNumber = gets(ENDPOINT_CRITICAL_ASSET_BY_STATUS_NUMBER, 'critical_asset_by_status_number');
export const getCriticalAssetByStatusValue = gets(ENDPOINT_CRITICAL_ASSET_BY_STATUS_VALUE, 'critical_asset_by_status_value');

export const getCriticalAssetByOrganization = gets(ENDPOINT_CRITICAL_ASSET_BY_ORGANIZATION, 'critical_asset_by_organization');
export const getDataActionTrackerTypes = gets(ENDPOINT_DATA_ACTION_TRACKER_TYPES, 'data_action_tracker_types');
export const getAcWithPrtFiles = gets(ENDPOINT_AC_WITH_PRT_FILES, 'ac_with_ptr_files');
export const getStandards = gets(ENDPOINT_STANDARDS, 'standards');
export const getUsers = gets(ENDPOINT_USERS, 'users');
export const getActionTrackerIssues = gets(ENDPOINT_ACTION_TRACKER_ISSUES, 'actionTrackerIssues');
export const getOrganizations = gets(ENDPOINT_ORGANIZATIONS, 'organizations');
export const getImpactedAreas = gets(ENDPOINT_IMPACTED_AREAS, 'impacted_areas');
export const getEbits = gets(ENDPOINT_EBITS, 'ebits');
export const getSpecialities = gets(ENDPOINT_SPECIALITIES, 'specialities');
export const getPwoCancelleds = gets(ENDPOINT_PWO_CANCELLEDS, 'pwoCancelleds');
export const getPwoOverdues = gets(ENDPOINT_PWO_OVERDUES, 'pwoOverdues');
export const getPwoCompliances = gets(ENDPOINT_PWO_COMPLIANCES, 'pwoCompliances');
//export const getCriticalAssets = gets(ENDPOINT_CRITICAL_ASSETS, 'criticalAssets');
export const getCriticalAssets = gets(ENDPOINT_CRITICAL_ASSET_DETAIL_FUNCTIONAL_LOCATION, 'criticalAssets');

export const getSpareParts = gets(ENDPOINT_SPARE_PARTS, 'spareParts');
export const getTrackActivities = gets(ENDPOINT_TRACK_ACTIVITIES, 'trackActivities');
export const getUserAssets = gets(ENDPOINT_USER_ASSETS, 'userAssets');
export const getPermissions = gets(ENDPOINT_PERMISSIONS, 'permissions');
export const getProfiles = gets(ENDPOINT_PROFILES, 'profiles');
export const getRoles = gets(ENDPOINT_ROLES, 'roles');
export const getActions = gets(ENDPOINT_ACTIONS, 'actions');

export const getDashboardKriPivotTable = gets(ENDPOINT_DASHBOARD_KRI_PIVOT_TABLE, 'kri_pivot_table');
export const getFiscalYears = gets(ENDPOINT_FISCAL_YEARS, 'fiscal_years');

export const getPaginatedActionTrackerIssues = gets(ENDPOINT_PAGINATED_ACTION_TRACKER_ISSUES, 'paginated_action_tracker_issues');
export const getDashboardMetricsReportTable = gets(ENDPOINT_DASHBOARD_METRICS_REPORT_TABLE, 'dashboard_metrics_report_table');
export const getDashboardMetricsSpecificHeaders = gets(ENDPOINT_DASHBOARD_METRICS_SPECIFIC_HEADERS, 'dashboard_metrics_specific_headers');


export const getLimit = gets(ENDPOINT_GET_LIMIT,'limit');
export const get_simulations_ca = gets(ENDPOINT_SIMULATIONS_CRITICAL_ASSETS,'simulations_ca');
export const get_simulations_sp = gets(ENDPOINT_SIMULATIONS_SPARE_PARTS,'simulations_sp');


var FileSaver = require('file-saver');
const responseType = 'arraybuffer';

export const getCriticalAssetsToCsv = (filters) => {
	
	return axios.get(ENDPOINT_CRITICAL_ASSETS_TO_CSV + setFilters(filters),
		{responseType})
		 .then(d => d.data)
		 .then(async res => {
		   const blob = new Blob([new Uint8Array(res)], {encoding:"UTF8", type: 'charset=UTF8;',charset: 'utf8' });
		   
		   
		   FileSaver.saveAs(blob, 'Reporte.xlsx');
		   return res;
	   });
}

export const getSparePartToCsv = (filters) => {
	return axios.get(ENDPOINT_SPARE_PART_TO_CSV + setFilters(filters), {responseType})
		.then(d => d.data)
		.then(async res => {
		const blob = new Blob([new Uint8Array(res)], {encoding:"UTF8", type: 'charset=UTF8;',charset: 'utf8' });

		
		FileSaver.saveAs(blob, 'Reporte.xlsx');
		return res;
	});
}

const createGetExport = (ENDPOINT) => (filters) => {
	return axios.get(ENDPOINT + setFilters(filters), {responseType})
		.then(d => d.data)
		.then(async res => {
		const blob = new Blob([new Uint8Array(res)], {encoding:"UTF8", type: 'charset=UTF8;',charset: 'utf8' });
		
		
		FileSaver.saveAs(blob, 'Reporte.xlsx');
		return res;
	});
}

export const getSimulationsComputedValuesCriticalAsset = createGetExport(ENDPOINT_SIMULATIONS_COMPUTED_VALUES_CRITICAL_ASSET);
export const getSimulationsComputedValuesSparePart = createGetExport(ENDPOINT_SIMULATIONS_COMPUTED_VALUES_SPARE_PART);
	
export const getExportMetrics = createGetExport(ENDPOINT_EXPORT_METRICS);/* a */
export const getExportEbits = createGetExport(ENDPOINT_EXPORT_EBITS);
export const getExportActionTrackerIssue = createGetExport(ENDPOINT_EXPORT_ACTION_TRACKER_ISSUE);
export const getExportActions = createGetExport(ENDPOINT_EXPORT_ACTIONS);
export const getExportKri = createGetExport(ENDPOINT_EXPORT_KRI);
export const getExportCriticalAssetPrtFiles  = createGetExport(ENDPOINT_EXPORT_CRITICAL_ASSET_PRT_FILES);
export const getExportCriticalAssetRevision  = createGetExport(ENDPOINT_EXPORT_CRITICAL_ASSET_REVISION);
export const getExportCriticalAssetHistorical = createGetExport(ENDPOINT_EXPORT_CRITICAL_ASSET_HISTORICAL);
export const getExportCriticalAssetDischarged = createGetExport(ENDPOINT_EXPORT_CRITICAL_ASSET_DISCHARGED);
export const getExportSparePartRevision = createGetExport(ENDPOINT_EXPORT_SPARE_PART_REVISION);
export const getExportSparePartHistorical = createGetExport(ENDPOINT_EXPORT_SPARE_PART_HISTORICAL);
export const getExportSparePartDischarged = createGetExport(ENDPOINT_EXPORT_SPARE_PART_DISCHARGED);
export const getExportUsers = createGetExport(ENDPOINT_EXPORT_USERS);
export const getExportTracking = createGetExport(ENDPOINT_EXPORT_TRACKING);
export const getExportAsiRequests = createGetExport(ENDPOINT_EXPORT_ASI_REQUESTS);

const get = (ENDPOINT_) => (id,n=true) => fetch(`${ENDPOINT_}${id}${n?'/':''}`,GET())
	.then(res => res.json());
	
export const get_discharge_part_files = get(ENDPOINT_DISCHARGE_PART_FILES);

export const get_simulations_critical_asset = (id) => fetch(ENDPOINT_SIMULATIONS_CRITICAL_ASSET + id + '/',GET())
	.then(res => res.json());

export const get_simulations_spare_part = (id) => fetch(ENDPOINT_SIMULATIONS_SPARE_PART + id + '/',GET())
	.then(res => res.json());


export const get_simulations_to_asi_request_critical_asset = (id) => fetch(ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_CRITICAL_ASSET + id + '/',POST({}))
	.then(res => res.json());

export const get_simulations_to_asi_request_spare_part = (id) => fetch(ENDPOINT_SIMULATIONS_TO_ASI_REQUEST_SPARE_PART + id + '/',POST({}))
	.then(res => res.json());

export const get_review_action = (id) => fetch(ENDPOINT_REVIEW_ACTION + id + '/',GET())
	.then(res => res.json());

export const getSparePartsSingle = (id) => fetch(ENDPOINT_SPARE_PART + id + '/',GET())
	.then(res => res.json());

export const getCriticalAssetsSingle = (id) => fetch(ENDPOINT_JOIN_CRITICAL_ASSET_DETAIL_FL + id + '/',GET())
	.then(res => res.json());

export const getDashboardKriIndividualTable = () => fetch(
	ENDPOINT_DASHBOARD_KRI_INDIVIDUAL_TABLE,
	GET())
	.then(res => res.json());

export const getDashboardMetricsSpecific = (filters) => fetch(
	ENDPOINT_DASHBOARD_METRICS_SPECIFIC + setFilters(filters),
	GET())
	.then(res => res.json());

export const getSheetUpdate = (id) => fetch(ENDPOINT_SHEET_UPDATE + id + '/',GET())
	.then(res => res.json());
	
export const getCriticalAssetDetail = (id) => fetch(
	ENDPOINT_CRITICAL_ASSET_DETAIL_FL + id + '/',
	GET())
	.then(res => res.json());

export const getCriticalAsset = (id) => fetch(
	ENDPOINT_CRITICAL_ASSET + id + '/',
	GET())
	.then(res => res.json());

export const getCriticalAssetPrtFiles = (id) => fetch(
	ENDPOINT_CRITICAL_ASSET_PRT_FILES + id + '/',
	GET())
	.then(res => res.json());
	
export const get_impact_percentage_files = (filters) => fetch(ENDPOINT_IMPACT_PERCENTAGE_FILES + setFilters(filters),GET())
	.then(res => res.json());

export const getDashboardActionTrackerIssueBarplot = (filters) => fetch(ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_BARPLOT + setFilters(filters),GET())
	.then(res => res.json());

export const getDashboardActionTrackerIssueDonut = (filters) => fetch(ENDPOINT_DASHBOARD_ACTION_TRACKER_ISSUE_DONUT + setFilters(filters),GET())
	.then(res => res.json());

export const getDashboardKriSummaryTable = (filters) => fetch(
	ENDPOINT_DASHBOARD_KRI_SUMMARY_TABLE,
	GET())
	.then(res => res.json());

export const getDashboardKriReportTable = (filters) => fetch(
	ENDPOINT_DASHBOARD_KRI_REPORT_TABLE,
	GET())
	.then(res => res.json());

export const helperGetCurrentFiscalYear = (filters) => fetch(
	ENDPOINT_HELPER_GET_CURRENT_FISCAL_YEAR,
	GET())
	.then(res => res.json());

export const functionCheckDischargeParts = (filters) => fetch(
	ENDPOINT_FUNCTION_CHECK_DISCHARGE_PARTS,
	GET())
	.then(res => res.json());

export const getPublicFile1 = (filters) => fetch(ENDPOINT_PUBLIC_FILE_1, GET())
	.then(res => res.json());

export const getKRI = (filters) => fetch(
	ENDPOINT_KRI + setFilters(filters),
	GET())
	.then(res => res.json());

	
export const getKris = (filters) => fetch(
	ENDPOINT_KRIS + setFilters(filters),
	GET())
	.then(res => res.json());

export const getGenericFiles = (filters) => fetch(
	ENDPOINT_GENERIC_FILES + setFilters(filters),
	GET())
	.then(res => res.json());

export const getFunction_dark_mode = () => fetch(
	ENDPOINT_FUNCTION_DARK_MODE,
	GET())
	.then(res => res.json());
	
	//export const getPrtFiles = (filters) => axios.get(ENDPOINT_PRT_FILES, {headers: headers(), body:filters} , filters )
	
export const getPrtFiles = (filters) => axios({
	method:'get',
	url:ENDPOINT_PRT_FILES,
	headers: {
		Accept: 'application/json',
		Authorization: `Bearer ${$store.getters.session.access}`,
		body:filters
	},
})
.then(e => e.data);

export const get_simulations_join_ca_with_scas = () => fetch(
	ENDPOINT_SIMULATIONS_JOIN_CA_WITH_SCAS,
	GET())
	.then(res => res.json());


/* export const getPrtFiles = (filters) => fetch(
	ENDPOINT_PRT_FILES + setFilters(filters),
	GET2(filters))
	.then(res => res.json()); */

// --------------ADD----------------------------------------------
/*

*/
const add = (ENDPOINT) => (obj) => fetch(
	ENDPOINT,
	POST(obj))
	.then(res => res.json());

const addMulti = (ENDPOINT) => (obj) => fetch(
	ENDPOINT,
	POSTmulti(obj))
	.then(res => res.json());
	
export const add_impact_percentage_files = addMulti(ENDPOINT_IMPACT_PERCENTAGE_FILES);
export const add_discharge_part_files = addMulti(ENDPOINT_DISCHARGE_PART_FILES);

export const add_simulations_ca = add(ENDPOINT_SIMULATIONS_CRITICAL_ASSETS);
export const add_simulations_sp = add(ENDPOINT_SIMULATIONS_SPARE_PARTS);

export const add_remediation_actions = add(ENDPOINT_REMEDIATION_ACTIONS);

export const add_action_photographic_records = addMulti(ENDPOINT_ACTION_PHOTOGRAPHIC_RECORDS);
export const add_action_documents = addMulti(ENDPOINT_ACTION_DOCUMENTS);
	
export const addCustomCreateUser = add(ENDPOINT_CUSTOM_CREATE_USER);


export const addFiscalYears = add(ENDPOINT_FISCAL_YEARS);
export const cacheToCriticalAsset = add(ENDPOINT_CACHE_TO_CRITICAL_ASSET);
export const addFilesCriticalAsset = addMulti(ENDPOINT_ADD_FILES_CRITICAL_ASSET);
export const createCriticalAssetCache = add(ENDPOINT_CREATE_CRITICAL_ASSET_CACHE);
export const addStandards = addMulti(ENDPOINT_STANDARDS);


export const serviceMailExpiredIssueTrackerAll = add(ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER_ALL);


export const serviceMailExpiredIssueTracker = (id) => fetch(
	ENDPOINT_SERVICE_MAIL_EXPIRED_ISSUE_TRACKER + id + '/',
	POST({}))
	.then(res => res.json());
	

// retorna la lista ptr & ea paginada dandole filtros por body
export const prtFilesFilter = (obj,obj2) => fetch(
	ENDPOINT_PRT_FILES_FILTER + setFilters(obj2),
	POST(obj))
	.then(res => res.json());

export const edit_kri_1_2 = (obj) => fetch(
	ENDPOINT_EDIT_KRI_1_2,
	POST(obj))
	.then(res => res.json());

export const addRoles = (obj) => fetch(
	ENDPOINT_ROLES,
	POST(obj))
	.then(res => res.json());

export const addProfiles = (obj) => fetch(
	ENDPOINT_PROFILES,
	POST(obj))
	.then(res => res.json());

export const addPermissions = (obj) => fetch(
	ENDPOINT_PERMISSIONS,
	POST(obj))
	.then(res => res.json());

export const addEbits = (obj) => fetch(
	ENDPOINT_EBITS,
	POST(obj))
	.then(res => res.json());

export const addSpareParts = (obj) => fetch(
	ENDPOINT_SPARE_PARTS,
	POST(obj))
	.then(res => res.json());
	
export const addCriticalAssets = (obj) => fetch(
	ENDPOINT_CRITICAL_ASSETS,
	POST(obj))
	.then(res => res.json());

	
export const uploadActions = (obj) => fetch(
	ENDPOINT_UPLOAD_ACTIONS,
	POSTmulti(obj))
	.then(res => res.json());

export const uploadKRI = (obj) => fetch(
	ENDPOINT_UPLOAD_KRI,
	POSTmulti(obj))
	.then(res => res.json());
	
export const uploadPwoSheet = (obj) => fetch(
	ENDPOINT_UPLOAD_PWO_SHEET,
	POSTmulti(obj))
	.then(res => res.json());	

export const uploadActionTracker = (obj) => fetch(
	ENDPOINT_UPLOAD_ACTION_TRACKER,
	POSTmulti(obj))
	.then(res => res.json());

export const uploadPrtFiles = (obj) => fetch(
	ENDPOINT_PRT_FILES,
	POSTmulti(obj))
	.then(res => res.json());
/* los archivos del wf... nombre segun lucas */
export const uploadGenericFiles = (obj) => fetch(
	ENDPOINT_GENERIC_FILES,
	POSTmulti(obj))
	.then(res => res.json());
/* export const add = (obj) => fetch(
	ENDPOINT,
	POST(obj))
	.then(res => res.json());

export const addTaskExecution = (obj) => fetch(
	ENDPOINT_TASK_EXECUTIONS,
	POSTmulti(obj))
	.then(res => res.json()); */


// -----------GET--------------------------------------------
/*

*/
/* 
export const getAditional_control = (id) => fetch(
	ENDPOINT_ADITIONAL_CONTROL + id + '/',
	GET())
	.then(res => res.json());
 */
export const getWorkflowCriticalAsset = (filters) => fetch(
	ENDPOINT_WORKFLOW_CRITICAL_ASSET + setFilters(filters) ,
	GET())
	.then(res => res.json());

export const get_action_workflows = (filters) => fetch(
	ENDPOINT_ACTION_WORKFLOWS + setFilters(filters) ,
	GET())
	.then(res => res.json());
	